import {
  GetPlaceLatLngResponse,
  GoogleAddress,
  GoogleGeocode,
} from "@web-app/types";
import http from "@web-app/utils/http";

const base_url = "/google";
const public_base_url = "/public/google";

export const getPlaceAutoCompletions = async (address: string) => {
  return http
    .get<GoogleAddress[]>(`${base_url}/autocomplete`, {
      params: {
        address: address,
      },
    })
    .then((response) => response.data);
};

export const getPublicPlaceAutoCompletions = async (address: string) => {
  return http
    .get<GoogleAddress[]>(`${public_base_url}/autocomplete`, {
      params: {
        address: address,
      },
    })
    .then((response) => response.data);
};

export const getPlaceLatLng = async (placeId: string) => {
  return http
    .get<GetPlaceLatLngResponse>(`${base_url}/placedetails`, {
      params: {
        placeId: placeId,
      },
    })
    .then((response) => response.data);
};

export const getPublicPlaceLatLng = async (placeId: string) => {
  return http
    .get<GetPlaceLatLngResponse>(`${public_base_url}/placedetails`, {
      params: {
        placeId: placeId,
      },
    })
    .then((response) => response.data);
};

export const getGeocode = async (address: string) => {
  return http
    .get<GoogleGeocode>(`${base_url}/geocode`, {
      params: {
        address: address,
      },
    })
    .then((response) => response.data);
};
